export default function() {
  return Array.from(this);
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-selection/src/selection/nodes.js